import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { MdClose, MdInsertInvitation } from "react-icons/md";
import { BsFillTelephoneFill, BsPersonFill } from "react-icons/bs";
import { MercedesCalendar } from "./Customs/col/mercedes-benz/MercedesCalendar";
import { MercedesTelephone } from "./Customs/col/mercedes-benz/MercedesTelephone";
import { MercedesLocation } from "./Customs/col/mercedes-benz/MercedesLocation";
import { FaArrowCircleLeft, FaArrowCircleRight, FaClock, FaLocationArrow } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { MercedesClock } from "./Customs/col/mercedes-benz/MercedesClock";
import { MercedesPerson } from "./Customs/col/mercedes-benz/MercedesPerson";
import { MercedesMail } from "./Customs/col/mercedes-benz/MercedesMail";
import { MercedesArrowBack } from "./Customs/col/mercedes-benz/MercedesArrowBack";
import { MercedesArrowForward } from "./Customs/col/mercedes-benz/MercedesArrowForward";
import { MercedesCloseIcon } from "./Customs/col/mercedes-benz/MercedesCloseIcon";
import { clipboardSearch } from "./Customs/default/clipboardSearch";
import { MercedesClipboard } from "./Customs/col/mercedes-benz/MercedesClipboard";
import { MercedesCancelIcon } from "./Customs/col/mercedes-benz/MercedesCancelIcon";

const defaultIcons = {
  calendar: MdInsertInvitation,
  telephone: BsFillTelephoneFill,
  location: FaLocationArrow,
  clock: FaClock,
  person: BsPersonFill,
  mail: IoMail,
  arrowBack: FaArrowCircleLeft,
  arrowForward: FaArrowCircleRight,
  closeIcon: MdClose,
  clipboard: clipboardSearch,
  cancelIcon: MdClose
};

const customIcons = {
  col: {
    "mercedes-benz": {
      calendar: MercedesCalendar,
      telephone: MercedesTelephone,
      location: MercedesLocation,
      clock: MercedesClock,
      person: MercedesPerson,
      mail: MercedesMail,
      arrowBack: MercedesArrowBack,
      arrowForward: MercedesArrowForward,
      closeIcon: MercedesCloseIcon,
      cancelIcon: MercedesCancelIcon,
      clipboard: MercedesClipboard
    }
  }
};
const DynamicIcon = ({ name, ...props }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const brand = params.get("brands")?.toLowerCase();
  const code = params.get("code")?.toLowerCase();
  const IconComponent = useMemo(() => {
    if (code && brand && customIcons[code]?.[brand][name]) {
      return customIcons[code]?.[brand][name];
    }
    return defaultIcons[name];
  }, [code, brand, name]);

  return <IconComponent {...props} />;
};

export default DynamicIcon;
